import React from 'react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Text,
    IconButton,

    /* Hooks */
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import SelectedRefinements from './selected-refinements'

/* Icons */
import { CustomClose } from '../../../components/icons'

const getSelectedFilterCount = (selectedRefinements, urlRefine) => {
    let count = 0
    const filterByUrlRefine =
        urlRefine && typeof urlRefine === 'object' && !Array.isArray(urlRefine)

    for (const key in selectedRefinements) {
        if (key === 'cgid' || key === 'htype') continue
        // Only count refinements the user actually applied via the URL. Auto-applied
        // refinements (e.g. from SFCC suggested-phrase rules) live in the API
        // selectedRefinements but not in the URL, and can't be removed client-side.
        if (filterByUrlRefine && !Object.prototype.hasOwnProperty.call(urlRefine, key)) continue

        const values = selectedRefinements[key]?.split('|')
        count += values.length
    }

    return count
}

const SelectedFiltersHeader = ({productSearchResult, toggleFilter, resetFilters, onClose, urlRefine}) => {
    const selectedRefinements = productSearchResult?.selectedRefinements || {}
    const numberOfSelectedFilters = getSelectedFilterCount(selectedRefinements, urlRefine)
    const styles = useMultiStyleConfig('PageFilters')

    return (
        <Box {...styles.sfhContainer}>
            <Flex align="center" justify="space-between">
                <Text {...styles.sfhNoFilter}>
                    {numberOfSelectedFilters > 0 ? (
                        <FormattedMessage
                            id="selected_filters_header.filters_selected"
                            defaultMessage="{count, plural, one {# filter selected} other {# filters selected}}"
                            values={{count: numberOfSelectedFilters}}
                        />
                    ) : (
                        <FormattedMessage
                            id="selected_filters_header.none_selected"
                            defaultMessage="No filter selected"
                        />
                    )}
                </Text>
                <IconButton
                    data-testid="filters-button-close"
                    variant={'unstyled'}
                    aria-label="Close"
                    icon={<CustomClose />}
                    {...styles.sfhCloseCTA}
                    onClick={onClose}
                />
            </Flex>

            <SelectedRefinements
                filters={productSearchResult?.refinements}
                toggleFilter={toggleFilter}
                handleReset={resetFilters}
                selectedFilterValues={selectedRefinements}
                urlRefine={urlRefine}
                spacing={{base: 1, lg: '10px'}}
            />
        </Box>
    )
}

SelectedFiltersHeader.propTypes = {
    productSearchResult: PropTypes.object,
    toggleFilter: PropTypes.func,
    resetFilters: PropTypes.func,
    onClose: PropTypes.func,
    urlRefine: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default SelectedFiltersHeader
